import * as Dialog from '@radix-ui/react-dialog';
import { styled } from 'styled-components';
import { Navbar } from '../Navbar';
import { Typography, tk } from '@sunwebgroup/ui-components';
import { MenuTrigger } from '../Menu/Trigger';
import { HeaderLink } from '../HeaderLink';

/**
 * This is the Sheet component used for the mobile version of the navigation menu.
 */

const Content = styled(Dialog.Content)`
  background: ${tk('color_semantic_bg')};
  height: calc(100vh - 100%); // 100% is the height of the header
  padding: ${tk('spacing_md')} 0;
  position: absolute;
  right: 0;
  top: 100%;
  width: 100vw;
  border-top: 1px solid ${tk('color_semantic_border')};
  z-index: 1;

  @media ${tk('mq_tablet')} {
    max-width: 375px;
  }

  @media ${tk('mq_desktop_md')} {
    display: none;
  }

  ${Navbar} {
    position: relative;
    height: 100%;

    & > div,
    ${Navbar.List} {
      height: 100%;
    }
    & > ${Typography}:first-child {
      display: block;
      padding: ${tk('spacing_sm')} ${tk('spacing_lg')};
    }
  }

  ${Navbar.List} {
    display: block;
    position: relative;
    overflow: auto;

    & > ${Typography} {
      display: block;
      margin-bottom: ${tk('spacing_sm')};
      padding: 0 ${tk('spacing_lg')};
    }

    & ${Navbar.Item} {
      & ${MenuTrigger} {
        padding: ${tk('spacing_sm')} ${tk('spacing_lg')};
        width: 100%;
        &:hover {
          color: inherit;
          background: ${tk('color_semantic_bg_subdued_hover')};
        }
      }
    }

    ${HeaderLink} {
      padding: ${tk('spacing_sm')} ${tk('spacing_lg')};
      width: 100%;
      &:hover {
        color: ${tk('color_semantic_text_primary')};
      }
    }

    ${Navbar.Content} {
      background: ${tk('color_semantic_bg')};
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;

      & > ${Typography}, & > button {
        display: flex;
        margin-bottom: ${tk('spacing_sm')};
        padding: 0 ${tk('spacing_lg')};
      }
    }
  }

  ${MenuTrigger} {
    border-radius: ${tk('radius_none')};
  }
`;

const Overlay = styled(Dialog.Overlay)`
  background: ${tk('color_palette_transparent_black_50')};
  height: calc(100vh - 100%);
  left: 0;
  position: absolute;
  top: 100%;
  width: 100vw;
  z-index: -1;

  @media ${tk('mq_desktop_md')} {
    display: none;
  }
`;

const Trigger = styled(Dialog.Trigger)`
  padding: ${tk('spacing_xs')} ${tk('spacing_md')};
  @media ${tk('mq_desktop_md')} {
    display: none;
  }
`;

export const Sheet = {
  Content,
  Overlay,
  Trigger,
  Root: styled(Dialog.Root)``,
  Close: styled(Dialog.Close)``,
  Portal: styled(Dialog.Portal)``,
};
